export default __webpack_public_path__ + "static/media/qf-logo.c8e4ac6f.png";